import React, { useState } from 'react';

import {
  JOIN_REQUEST_STATES,
  SUGGESTED_WORKSPACES_STEP,
  WORKSPACE_CREATE_STEP,
} from '../../constants';
import { getStepComponentFromKey } from '../../utilities';

function WorkspaceSetupStep({ nextClickHandler, nextStepHandler, isMobile }) {
  const [joinRequestState, setJoinRequestState] = useState();
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [SUGGESTED_WORKSPACES_STEP, WORKSPACE_CREATE_STEP];

  function onNextClick({ joinState } = {}) {
    if (
      // Skip the invite teammates step if we've requested to join a workspace
      (steps[currentStep] === WORKSPACE_CREATE_STEP &&
        joinRequestState === JOIN_REQUEST_STATES.REQUESTED) ||
      // Skip the rest of the steps if the user has autojoined a workspace.
      joinState === JOIN_REQUEST_STATES.AUTOJOINED
    ) {
      nextStepHandler(2);

      return;
    }

    if (currentStep === steps.length - 1) {
      nextClickHandler();

      return;
    }

    setCurrentStep(currentStep + 1);
    setJoinRequestState(joinState);
  }

  function onBackClick() {
    setCurrentStep(Math.max(currentStep - 1, 0));
  }

  const CurrentStepComponent = getStepComponentFromKey(steps[currentStep]);

  return (
    <CurrentStepComponent
      nextClickHandler={onNextClick}
      backClickHandler={onBackClick}
      joinRequestState={joinRequestState}
      isMobile={isMobile}
    />
  );
}

export default WorkspaceSetupStep;
